import { SOCIAL_MEDIA_LINKS } from 'config';

const BASE_URL = 'https://abbeydentalsupplies.com';

export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Abbey Dental Supplies',
  url: BASE_URL,
  logo: `${BASE_URL}/images/logo.png`,
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+442086834528',
    contactType: 'customer service',
    availableLanguage: 'English',
  },
  sameAs: [
    SOCIAL_MEDIA_LINKS.FACEBOOK,
    SOCIAL_MEDIA_LINKS.INSTAGRAM,
    SOCIAL_MEDIA_LINKS.LINKEDIN,
  ],
};

export const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: 'Abbey Dental Supplies',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '4 Imperial Way',
    addressLocality: 'Croydon',
    postalCode: 'CR0 4RR',
    addressCountry: 'GB',
  },
  telephone: '02086834528',
  url: BASE_URL,
  openingHours: 'Mo-Fr 09:00-17:00',
};

export const webSiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  url: BASE_URL,
  potentialAction: {
    '@type': 'SearchAction',
    target: `${BASE_URL}/shop?search={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

interface ProductSchemaOptions {
  name: string;
  sku: string;
  description: string;
  image: string;
  price: number;
  priceCurrency?: string;
  inStock: boolean;
}

export function buildProductSchema(opts: ProductSchemaOptions) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: opts.name,
    sku: opts.sku,
    description: opts.description,
    image: opts.image,
    offers: {
      '@type': 'Offer',
      price: opts.price.toFixed(2),
      priceCurrency: opts.priceCurrency || 'GBP',
      availability: opts.inStock
        ? 'https://schema.org/InStock'
        : 'https://schema.org/OutOfStock',
    },
  };
}

interface BreadcrumbItem {
  name: string;
  url: string;
}

export function buildBreadcrumbSchema(items: BreadcrumbItem[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}
